// reset swiperset
S.swiperset = {
    removeDuplicateId()
    {
        $('.swiper-slide').each((index, e) =>
        {
            if ($(e).hasClass('swiper-slide-duplicate'))
            {
                $(e).find('a').attr('tabindex', '-1');
                $(e).find('h2').removeAttr('id');
                $(e).find('h3').removeAttr('id');
            }
        });
    },

    getSlideMessage(lang)
    {
        const slideMessageArray = [];

        if (lang === 'de')
        {
            slideMessageArray['prev'] = 'Vorhergehender Slide';
            slideMessageArray['next'] = 'Nächster Slide';
        }
        else
        {
            slideMessageArray['prev'] = 'Previous slide';
            slideMessageArray['next'] = 'Next slide';
        }

        return slideMessageArray;
    },

    resetsrc(elem)
    {
        // stop video intern
        elem.find('.swiper-slide-active video').attr('src', elem.find('.swiper-slide-active video').attr('src'));

        // stop audio intern
        elem.find('.swiper-slide-active audio').attr('src', elem.find('.swiper-slide-active audio').attr('src'));

        // stop youtube or extern player
        elem.find('.swiper-slide-active iframe').attr('src', elem.find('.swiper-slide-active iframe').attr('src'));
    },

    // type: 1=eckig | 2=rund
    setArrows(mod, type = 1)
    {
        // xTODO round arrows different offset
        let offset = 81;

        if (type === 2)
        {
            offset = 30;
        }

        // tablet only
        if (!S.mq('desktop', false).matches)
        {
            offset = 50;

            if (type === 2)
            {
                offset = 25;
            }
        }
        // mobile only
        if (!S.mq('tablet', false).matches)
        {
            offset = 30;

            if (type === 2)
            {
                offset = 25;
            }
        }

        if ($(mod + ' video').length > 0 || $(mod + ' picture').length > 0)
        {
            let topImg = 0;

            if ($(mod + ' video').length > 0)
            {
                topImg = $(mod + ' video').height();
            }

            if ($(mod + ' picture').length > 0)
            {
                topImg = $(mod + ' picture').height();
            }

            // console.log(topImg);
            if (topImg !== null)
            {
                topImg = (topImg / 2) - offset;

                // this.$module.find('.swiper-button-prev').css({top: topImg + 'px'});
                // this.$module.find('.swiper-button-next').css({top: topImg + 'px'});
                // bei mehreren instanzen geht es nur so....
                $(mod + ' .swiper-button-prev').css({top: topImg + 'px'});
                $(mod + ' .swiper-button-next').css({top: topImg + 'px'});
            }
        }

        $(window).on('resize', () =>
        {
            S.delayed('resize-obj', 250, () =>
            {
                this.setArrows(mod, type);
            });
        });
    },
};
